import store from "@/store";

var ActingUserAuthenticationHandler = (function () {
    var initialize = function () {
        return store.dispatch('actingUser/refreshActingUserDetails')
    }

    var terminate = function () {
        return store.dispatch('actingUser/clearActingUserDetails')
    }

    return {
        initialize: initialize,
        terminate: terminate
    }
}());

export default ActingUserAuthenticationHandler;
